import {Box, Typography} from '@mui/material';
import React from 'react';
import {useBrandTheme} from '../useBrandTheme';

interface HardLogoProps {
  variant: `light` | `dark`;
}

export const HardLogo: React.FC<HardLogoProps> = ({variant}) => {
  const theme = useBrandTheme();

  const isLight = variant === `light`;

  return (
    <Box
      sx={{
        display: `flex`,
        alignItems: `center`,
        gap: 1,
        userSelect: `none`,
      }}
    >
      <Typography
        sx={{
          fontSize: `22px`,
          fontWeight: 900,
          ...(isLight
            ? {
                color: theme.custom.colors.ui.white,
                textShadow: `0 2px 4px rgba(0, 0, 0, 0.4)`,
              }
            : {
                color: `#1a1a1a`, // Very dark black
              }),
          fontFamily: `"Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif`,
          letterSpacing: `-0.8px`,
        }}
      >
        Hārd
      </Typography>
    </Box>
  );
};
